<template>
  <Modal :title="title" :showModal="showModal" class="edit-cash-flow-form" @submit="submit">
    <template v-slot:body>
      <div class="row">
        <div class="form-group row col-12 m-0 mb-3 align-items-center">
          <label class="col-12 p-0">Type</label>
          <input type="date" class="form-control flex-1" data-title="Date" :value="data.date_created" @change="store.commit('date_created', $event.currentTarget.value)" />
          <div class="col-5 pr-0">
            <Select :options="more.type || []" placeholder="Type" :value="data.type" @changeValue="store.commit('type', $event)"></Select>
          </div>
        </div>
        <div class="position-relative form-group col-12">
          <label>Sales Account</label>
          <div class="input-group">
            <Select source="sale-account/search" placeholder="Sales Account" :value="data.account_id" @changeValue="store.commit('account_id', $event)"></Select>
          </div>
        </div>
        <div class="form-group row col-12 m-0 mb-2 align-items-center">
          <label class="col-12 p-0">Price:</label>
          <input class="form-control flex-1" type="text" placeholder="Price" name="meta[price]" :value="meta.price || ''" @change="store.commit('meta.price', $event.currentTarget.value)" />
          <select class="form-control col-3 ml-3" name="purchase[currency]" :value="meta.currency" @change="store.commit('meta.currency', $event.currentTarget.value)">
            <option v-for="(currency, index) in more.currency" :key="index" :value="index">
              {{ currency.label }}
            </option>
          </select>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import Event from '@/helper/event.js'
import moment from 'moment'
export default {
  mixins: [Event],
  data() {
    return {
      modal: false
    }
  },
  computed: {
    title() {
      return this.data.status == 'draft' ? 'Create Cash Flow' : 'Edit Cash Flow'
    },
    action() {
      return 'edit'
    },
    storeId() {
      return this.config?.storeId
    },
    accountId() {
      return this.config?.data?._id
    },
    getUri() {
      return `cash-flow/get/${this.accountId}`
    },
    submitUri() {
      return `cash-flow/update/${this.accountId}`
    },
    data() {
      return this.store.getter('', {})
    },
    meta() {
      return Object.assign({}, this.data.meta || {})
    },
    more() {
      return Object.assign(
        {
          currency: {},
          type: []
        },
        this.data.more || {}
      )
    }
  },
  created() {
    this.store.commit('', {})
  },
  methods: {
    setUpData(rawData) {
      if (rawData.status == 'success') {
        this.showModal = true
        rawData.data.meta = Object.assign({}, rawData.data.meta)
        if (rawData.data.date_created > 0) {
          rawData.data.date_created = moment.unix(rawData.data.date_created).format('Y-MM-DD')
        } else {
          rawData.data.date_created = moment().format('Y-MM-DD')
        }
        this.store.commit('', rawData.data)
      }
    },
    submit() {
      this.submitForm(this.data, {
        done: () => {
          this.$emit('close')
          this.$emitter.emit('TableList.Refresh')
        }
      })
    }
  },
  props: {
    config: Object
  }
}
</script>
